




































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import ModalBase from '@/components/ModalBase.vue';
import ProductCardInner from '@/components/ProductCardInner.vue';
import Card from '@/components/Card.vue';
import Button from "@/components/Button.vue";
import GTMService from "@/services/GTMService";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import { isWishope } from "../common/utils";

const ProductATCModalProps = Vue.extend({
  computed: {
    ...mapGetters("vas", [
      "merchant",
    ]),
  },
  methods: {
    isWishope,
  },
});

@Component({
  components: {
    ModalBase,
    Card,
    Button,
    ProductCardInner
  }
})

export default class ProductATCModal extends ProductATCModalProps {
  @Prop({ required: true}) readonly activeProduct!: MerchantProduct
  @Prop({ required: true}) readonly cart!: MerchantCart

  currentQuantity: number = 0
  product: any = null;

  created()
  {
    this.product = this.activeProduct;
  }

  @Watch('activeProduct') onActiveProductChanged() {
    this.product = this.activeProduct;

    if(this.product)
    {
      GTMService.dataLayerProductDetail(this.product, this.merchant);
    }
  }

  get quantityInCart () {
    if (this.product && this.cart && this.cart.products) {
      const cartItem = this.cart.products.find(line => line.id === this.product.id)
      return cartItem ? cartItem.requestedQuantity : 0
    }
    return 0
  }

  get quantityChanged () {
    return 0 !== this.currentQuantity
  }

  handleQuantity ({ quantity = 0 }) {
    this.currentQuantity = quantity
  }

  handleVariant(event = {}, variant: MerchantProduct){
    console.log(event, variant);
    this.currentQuantity = 0;
    const p = JSON.parse(JSON.stringify(this.product))
    this.product = {
      ...variant,
      hasCoverPhoto: p.hasCoverPhoto,
      description: p.description,
      thumb: p.thumb,
      name: p.name
    };
  }

  handleCancel () {
    this.$emit('cancel')
  }

  handleConfirm () {
    this.$emit('change', { quantity: this.currentQuantity, product: this.product })
  }

  handleRemove () {
    this.$emit('change', { quantity: 0, product: this.product })
  }

  @Watch('product.id')
  handleProductUpdate () {
    if (this.product && this.cart && this.cart.products) {
      const cartItem = this.cart.products.find(line => line.id === this.product.id)
      if (cartItem) {
        this.currentQuantity = cartItem.requestedQuantity
      }
    } else {
      this.currentQuantity = 0
    }
  }
}
